import {BikeCategory} from './BikeCategory';



export const PRICE_CATEGORY_INSPECTION = {
  [BikeCategory.CITYBIKE_URBANBIKE]: {
    '<1000': {1: {monthly: 0.00, total: 5}, 2: {monthly: 9.84, total: 9.84}},
    '1000-3500': {1: {monthly: 1.79, total: 5}, 2: {monthly: 12.89, total: 12.89}},
    '>3500': {1: {monthly: 1.79, total: 5}, 2: {monthly: 12.89, total: 12.89}},
  },
  [BikeCategory.TREKKINGBIKE_MTB_ATB]: {
    '<1000': {1: {monthly: 0.00, total: 5}, 2: {monthly: 9.84, total: 9.84}},
    '1000-3500': {1: {monthly: 1.79, total: 5}, 2: {monthly: 12.89, total: 12.89}},
    '>3500': {1: {monthly: 1.79, total: 5}, 2: {monthly: 12.89, total: 12.89}},
  },
  [BikeCategory.RENNRAD_GRAVELBIKE_CROSSBIKE_FITNESSBIKE]: {
    '<1000': {1: {monthly: 0.00, total: 5}, 2: {monthly: 9.84, total: 9.84}},
    '1000-3500': {1: {monthly: 1.79, total: 5}, 2: {monthly: 12.89, total: 12.89}},
    '>3500': {1: {monthly: 1.79, total: 5}, 2: {monthly: 12.89, total: 12.89}},
  },
  [BikeCategory.LASTENRAD]: {
    '<1000': {1: {monthly: 0.00, total: 5}, 2: {monthly: 9.84, total: 9.84}},
    '1000-3500': {1: {monthly: 2.50, total: 5}, 2: {monthly: 12.89, total: 12.89}},
    '>3500': {1: {monthly: 2.50, total: 5}, 2: {monthly: 12.89, total: 12.89}},
  },
  [BikeCategory.E_BIKE_PEDELEC]: {
    '<1000': {1: {monthly: 0.00, total: 5}, 2: {monthly: 9.84, total: 9.84}},
    '1000-3500': {1: {monthly: 5.00, total: 5}, 2: {monthly: 12.89, total: 12.89}},
    '>3500': {1: {monthly: 5.00, total: 5}, 2: {monthly: 12.89, total: 12.89}},
  },
  [BikeCategory.OTHER]: {
    '<1000': {1: {monthly: 0.00, total: 5}, 2: {monthly: 9.84, total: 9.84}},
    '1000-3500': {1: {monthly: 5.00, total: 5}, 2: {monthly: 12.89, total: 12.89}},
    '>3500': {1: {monthly: 5.00, total: 5}, 2: {monthly: 12.89, total: 12.89}},
  }
};
